import Swiper from "swiper";
import SwiperCore, {Navigation, Autoplay, Pagination} from "swiper/core";

SwiperCore.use([Navigation, Autoplay, Pagination]);
import {productPage} from "../modules/elements.js";
import {productItemSectionSlider} from "../modules/sliders.js";

function configurationSwiper() {
    const swiperConfiguration = new Swiper(
        productPage.querySelector("[data-swiper='configuration-slider']"),
        {
            spaceBetween: 20,
            // loop: true,
            slideClass: "configuration-card",
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            navigation: {
                nextEl: ".configuration-slider__next",
                prevEl: ".configuration-slider__prev",
            },
            breakpoints: {
                1920: {
                    slidesPerView: 3,
                },

                1200: {
                    slidesPerView: 2,
                },
            },
        }
    );
}

let swiperTechSpecs, swiperProductItem, swiperReviewsSection, swiperFaqSection;
const clazz = "product-item-grid__col";

function productItemSlider() {
    if (swiperProductItem){
        swiperProductItem.destroy();
    }
    if (matchMedia("(max-width: 767px)").matches) {
        swiperProductItem = new Swiper(
            productPage.querySelector('[data-swiper="product-item"]'),
            {
                slidesPerView: 1,
                spaceBetween: 10,
                loop: true,
                slideClass: "photos__item",
                // createElements: true,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
                grabCursor: true,
            }
        );

    } else {
        if (swiperProductItem) {
            swiperProductItem.destroy();
        }
        return;
    }
}

function compareSwiper() {
    const swiperCompare = new Swiper(
        productPage.querySelector("[data-swiper='compare-section']"),
        {
            slidesPerView: 2,
            slideClass: "compare-section__item",
            loop: true,
            navigation: {
                nextEl: `.slider__next-compare-section`,
                prevEl: `.slider__prev-compare-section`,
            },
            breakpoints: {
                1920: {
                    slidesPerView: 4,
                },

                1024: {
                    slidesPerView: 4,
                },
                768: {
                    slidesPerView: 2,
                },
            },
        }
    );
}


function compareModalSwiper() {
    const swiperCompareModal = new Swiper(
        document.querySelector("[data-swiper='compare-modal']"),
        {
            slidesPerView: 2,
            slideClass: "compare-item",
            // loop: true,
            navigation: {
                nextEl: `.slider__next-compare-modal`,
                prevEl: `.slider__prev-compare-modal`,
            },
            breakpoints: {
                1920: {
                    slidesPerView: 4,
                },

                1024: {
                    slidesPerView: 4,
                },
                768: {
                    slidesPerView: 2,
                },
            },
        }
    );
}


function featuredSlider() {
    const swiperFeatured = new Swiper(
        document.querySelector("[data-swiper='featured-section']"),
        {
            slidesPerView: 1.5,
            spaceBetween: 20,
            slideClass: "product",
            loop: true,
            navigation: {
                nextEl: `.slider__next-featured-section`,
                prevEl: `.slider__prev-featured-section`,
            },
            breakpoints: {
                1920: {
                    slidesPerView: 4,
                },

                1024: {
                    slidesPerView: 4,
                },
                768: {
                    slidesPerView: 3,
                },
            },
        }
    );
}

function dealsSlider() {
    const swiperDeals = new Swiper(
        document.querySelector("[data-swiper='deals-section']"),
        {
            slidesPerView: 1.5,
            spaceBetween: 20,
            slideClass: "catalog-item",
            loop: true,
            navigation: {
                nextEl: `.slider__next-deals-section`,
                prevEl: `.slider__prev-deals-section`,
            },
            breakpoints: {
                1920: {
                    slidesPerView: 4,
                },

                1024: {
                    slidesPerView: 4,
                },
                768: {
                    slidesPerView: 3,
                },
            },
        }
    );
}

function configurationProductSlider(value) {
    const configurationProductSlider = new Swiper(
        document.querySelector(`[data-swiper='configuration-slider-${value}']`),
        {
            slidesPerView: 1.25,
            spaceBetween: 20,
            slideClass: "include-item",
            grabCursor: true,
            navigation: {
                nextEl: `.configuration-slider-${value}__next`,
                prevEl: `.configuration-slider-${value}__prev`,
            },
            breakpoints: {
                1920: {
                    slidesPerView: 4,
                },

                1440: {
                    slidesPerView: 3,
                },
                768: {
                    slidesPerView: 2,
                },
            },
        }
    );

}

export default function productPageSliders() {
    productItemSlider();
    configurationSwiper();
    productItemSectionSlider("reviews-section", clazz, swiperReviewsSection);
    productItemSectionSlider("tech-specs", clazz, swiperTechSpecs);
    productItemSectionSlider("faq-section", clazz, swiperFaqSection);

    compareModalSwiper();
    featuredSlider();

    window.addEventListener("resize", () => {
        productItemSlider();
        productItemSectionSlider("reviews-section", clazz, swiperReviewsSection);
        productItemSectionSlider("tech-specs", clazz, swiperTechSpecs);
        productItemSectionSlider("faq-section", clazz, swiperFaqSection);
    });
}



export {compareModalSwiper, configurationProductSlider, dealsSlider, productItemSlider, compareSwiper};